import { Button, Row, Space, Upload } from 'antd'
import { RcFile, UploadProps } from 'antd/lib/upload'
import React, { ForwardedRef, ReactNode } from 'react'
import { SingleUploadRef, useSetupHook } from './hooks'
import { CloseCircleFilled } from '@ant-design/icons'
import PreviewModal from '../previewModal'
import { UploadFileItem } from '../BatchUpload'
export interface Props extends Omit<UploadProps, 'onChange'> {
  value?: any
  onChange?: (newUploadFileList?: UploadFileItem) => void
  customProps?: {
    tips?: ReactNode
    validateFile?: (file: RcFile) => boolean
    canPreview?: boolean
    onUploadSucceed?: (file: UploadFileItem) => void
    onDel?: (file: UploadFileItem) => void
  }
}
// eslint-disable-next-line react/display-name
const SingleUpload = React.forwardRef(function (
  props: Props,
  ref: ForwardedRef<SingleUploadRef>,
) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { customProps, onChange, ...restProps } = props
  const { tips, canPreview = true } = customProps || {}
  const {
    state,
    uploadButtonRef,
    handleBeforeUpload,
    cancelPreviewModal,
    showPreviewModal,
    handleDelFile,
  } = useSetupHook(props, ref)
  const { isLoading, uploadFileList, previewModalOption } = state
  return (
    <div>
      {uploadFileList.length < 1 ? (
        <Row>
          <Space>
            <Upload
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              {...restProps}
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
              disabled={isLoading}
            >
              <Button size="middle" loading={isLoading} ref={uploadButtonRef}>
                选择文件
              </Button>
            </Upload>
            {tips ? <span>{tips}</span> : null}
          </Space>
        </Row>
      ) : (
        <Row>
          <Space>
            <span
              className="btn-link"
              onClick={canPreview ? showPreviewModal : undefined}
            >
              {uploadFileList[0].name}
            </span>
            <CloseCircleFilled
              style={{
                cursor: 'pointer',
              }}
              onClick={handleDelFile}
            />
          </Space>
        </Row>
      )}
      <PreviewModal
        {...previewModalOption}
        onCancel={cancelPreviewModal}
      ></PreviewModal>
    </div>
  )
})
export default SingleUpload
import { Button, Row, Space, Upload } from 'antd'
import { RcFile, UploadProps } from 'antd/lib/upload'
import React, { ForwardedRef, ReactNode } from 'react'
import { SingleUploadRef, useSetupHook } from './hooks'
import { CloseCircleFilled } from '@ant-design/icons'
import PreviewModal from '../previewModal'
import { UploadFileItem } from '../BatchUpload'
export interface Props extends Omit<UploadProps, 'onChange'> {
  value?: any
  onChange?: (newUploadFileList?: UploadFileItem) => void
  customProps?: {
    tips?: ReactNode
    validateFile?: (file: RcFile) => boolean
    canPreview?: boolean
    onUploadSucceed?: (file: UploadFileItem) => void
    onDel?: (file: UploadFileItem) => void
  }
}
// eslint-disable-next-line react/display-name
const SingleUpload = React.forwardRef(function (
  props: Props,
  ref: ForwardedRef<SingleUploadRef>,
) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { customProps, onChange, ...restProps } = props
  const { tips, canPreview = true } = customProps || {}
  const {
    state,
    uploadButtonRef,
    handleBeforeUpload,
    cancelPreviewModal,
    showPreviewModal,
    handleDelFile,
  } = useSetupHook(props, ref)
  const { isLoading, uploadFileList, previewModalOption } = state
  return (
    <div>
      {uploadFileList.length < 1 ? (
        <Row>
          <Space>
            <Upload
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              {...restProps}
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
              disabled={isLoading}
            >
              <Button size="middle" loading={isLoading} ref={uploadButtonRef}>
                选择文件
              </Button>
            </Upload>
            {tips ? <span>{tips}</span> : null}
          </Space>
        </Row>
      ) : (
        <Row>
          <Space>
            <span
              className="btn-link"
              onClick={canPreview ? showPreviewModal : undefined}
            >
              {uploadFileList[0].name}
            </span>
            <CloseCircleFilled
              style={{
                cursor: 'pointer',
              }}
              onClick={handleDelFile}
            />
          </Space>
        </Row>
      )}
      <PreviewModal
        {...previewModalOption}
        onCancel={cancelPreviewModal}
      ></PreviewModal>
    </div>
  )
})
export default SingleUpload
